import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import NumberFormat from 'react-number-format';
import { useHistory } from 'react-router-dom';
import { Badge, Button, Col, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner, UncontrolledDropdown, UncontrolledTooltip } from 'reactstrap';
import { active, ban, findAllProperties } from '../../../../helpers/api/condominium';
import { SUCCESS_RESPONSE } from '../../../../helpers/codeResponses/codes';
import handleErrorMessage from '../../../../helpers/errors/handleErrorMessage';
import { Toast } from '../../../UI/toast/Toast';
import WizardError from '../../../auth/register/WizardError';

const CondominiumRow = ({ acronym, name, identification, created_at, address, state, city, condominium_id: id, mutate, manager, banned, properties_count }) => {

    const history = useHistory();
    const [submitting, setSubmitting] = useState(false);
    const [collapseOne, collapseOneOpen] = useState(false);
    const [reason, setReason] = useState('');
    const [properties, setProperties] = useState(properties_count || 0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (properties_count !== undefined) {
            setProperties(properties_count);
        }
    }, [properties_count]);
    const copyToClipboard = async (value, label) => {
        if (!value || !navigator?.clipboard) {
            return;
        }

        try {
            await navigator.clipboard.writeText(value);
            Toast.fire({ title: `${label} copiado al portapapeles.`, type: 'success' });
        } catch (error) {
            Toast.fire({ title: `No se pudo copiar el ${label.toLowerCase()}.`, type: 'error' });
        }
    };

    const deleteCondominium = () => {
        setSubmitting(true);
        ban(id, reason)
            .then(({ code }) => {
                if (code === SUCCESS_RESPONSE.OK) {
                    Toast.fire({ title: 'Condominio desactivado exitosamente.', type: 'success' });
                    mutate();
                }
            })
            .catch(error => handleErrorMessage(error))
            .finally(() => {
                setSubmitting(false);
                collapseOneOpen(false);
            });
    }

    const activeCondominium = () => {
        setSubmitting(true);
        active(id, reason)
            .then(({ code }) => {
                if (code === SUCCESS_RESPONSE.OK) {
                    Toast.fire({ title: 'Condominio activado exitosamente.', type: 'success' });
                    mutate();
                }
            })
            .catch(error => handleErrorMessage(error))
            .finally(() => {
                setSubmitting(false);
                collapseOneOpen(false);
            });
    }

    const handleModalConfirm = () =>
        <Modal isOpen={collapseOne} data-testid="modal">
            <ModalHeader>Confirmación</ModalHeader>
            <ModalBody>
                <p>{!banned ? '¿Está seguro de desactivar este condominio?' : '¿Está seguro de activar este condominio?'}</p>
                <Row form>
                    <Col tag={FormGroup}>
                        <Label>Ingrese la razón</Label>
                        <Input type='text' onChange={({ target }) => setReason(target.value)} />
                        <WizardError className='fs--1' error={!reason ? 'La razón es requerida.' : ''} />
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button onClick={() => collapseOneOpen(false)}>
                    Cancelar
                </Button>
                <Button
                    data-testid="submit-button"
                    color="primary"
                    type='submit'
                    disabled={submitting || !reason}
                    onClick={() => !banned ? deleteCondominium() : activeCondominium()}
                >{!banned ? 'Desactivar' : 'Activar'} {submitting && <Spinner size='sm' color='white' />}</Button>
            </ModalFooter>
        </Modal>

    return <tr key={id}>
        <td className='align-middle'>
            <Row>
                <Col><span>{name}</span></Col>
            </Row>
            <Row>
                <Col><span><b>{identification}</b></span></Col>
            </Row>
            <Row>
                <Col><span><b>{loading ? <Spinner size='sm' /> : `${properties} propiedades`}</b></span></Col>
            </Row>
        </td>
        <td className='align-middle'><p className='mb-0'>{address}</p></td>
        <td className='align-middle'>{state?.trim() || '-'}</td>
        <td className='align-middle'>{city?.trim() || '-'}</td>
        <td className='align-middle'>
            <Row>
                <Col>
                    <b><NumberFormat prefix={`${manager?.data?.dni?.charAt(0)}-`} thousandSeparator value={manager?.data?.dni.substring(1, 50)} displayType='text' /></b>
                </Col>
            </Row>
            <Row>
                <Col>
                    {manager?.data?.firstname} {manager?.data?.lastname}
                </Col>
            </Row>
            <Row> 
                <Col>
                    {manager?.data?.phone}
                </Col>
            </Row>
            <Row>    
                <Col>
                    {manager?.username && <div className='d-flex align-items-center' style={{ minWidth: 0, gap: '0.4rem' }}>
                        <span id={`manager-email-${id}`} className='text-truncate' style={{ maxWidth: '100%' }}>
                            {manager?.username}
                        </span>
                        <button
                            type='button'
                            className='btn btn-link btn-sm p-0 text-500'
                            id={`manager-email-copy-${id}`}
                            onClick={() => copyToClipboard(manager?.username, 'Correo')}
                            aria-label='Copiar correo del administrador'
                        >
                            <FontAwesomeIcon icon='copy' />
                        </button>
                        <UncontrolledTooltip placement='top' target={`manager-email-${id}`}>
                            {manager?.username}
                        </UncontrolledTooltip>
                        <UncontrolledTooltip placement='top' target={`manager-email-copy-${id}`}>
                            Copiar correo
                        </UncontrolledTooltip>
                    </div>}
                </Col>
            </Row>
        </td>
        <td className='align-middle text-center fs-0'>
            {!banned ? <Badge color='success' pill >Activo</Badge> : <>
                <Row><Col><Badge color='danger' pill id='bannedreason' className='mb-2' >Desactivado</Badge></Col></Row>
                <Row><Col><p className='fs--1 mb-0'>Razón: <b>{banned?.reason}</b></p></Col></Row>
            </>}
        </td>
        <td className='align-middle text-center'>
            <UncontrolledDropdown direction="left">
                <DropdownToggle color="falcon-default" size="sm">
                    <FontAwesomeIcon icon="ellipsis-h" />
                </DropdownToggle>
                <DropdownMenu right>
                    <DropdownItem onClick={() => history.push(`/root/condominiums/${id}/service`)}>Registrar servicio</DropdownItem>
                    <DropdownItem onClick={() => history.push(`/root/condominiums/${id}/status`)}>Ver estado de servicio</DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem onClick={() => history.push(`/root/condominiums/${id}/edit`)}>Editar</DropdownItem>
                    {!banned && <DropdownItem className="text-danger" onClick={() => collapseOneOpen(true)} >Desactivar condominio</DropdownItem>}
                    {banned && <DropdownItem className="text-success" onClick={() => collapseOneOpen(true)} >Activar condominio</DropdownItem>}
                </DropdownMenu>
            </UncontrolledDropdown>
        </td>
        {handleModalConfirm()}
    </tr>
}

export default CondominiumRow;